import { useMemo } from 'react';
import { useUserList } from '../../../hooks/users/useUserList.js';
import UserTable from '../../../components/tables/users/UserTable.jsx';
import SearchBar from '../../../components/utils/SearchBar.jsx';
import Pagination from '../../../components/utils/Pagination.jsx';
import SuccessModal from '../../../components/modales/SuccessModal.jsx';
import ErrorModal from '../../../components/modales/ErrorModal.jsx';
import DeleteModal from '../../../components/modales/DeleteModal.jsx';
import SuspendModal from '../../../components/modales/SuspendModal.jsx';

export default function ListUser() {
    const {
        users,
        searchTerm,
        setSearchTerm,
        currentPage,
        setCurrentPage,
        itemsPerPage,
        userToDelete,
        setUserToDelete,
        userToSuspend,
        setUserToSuspend,
        confirmDelete,
        confirmSuspend,
        success,
        setSuccess,
        error,
        setError,
        handleSort,
        sortField,
        sortOrder   
    } = useUserList();

    // FILTRO POR BÚSQUEDA
    const filteredUsers = useMemo(() => {
        const search = searchTerm.toLowerCase();

        return users.filter(user => {
            return (
                (user.userRole?.name || '').toLowerCase().includes(search) ||
                (user.userCompany?.name || '').toLowerCase().includes(search) ||
                (user.name || '').toLowerCase().includes(search) ||
                (user.lastname || '').toLowerCase().includes(search) ||
                (user.username || '').toLowerCase().includes(search) ||
                (user.email || '').toLowerCase().includes(search) ||
                (user.suspended ? 'suspendido' : 'activo').includes(search)
            );
        });
    }, [users, searchTerm]);

    // PAGINACIÓN
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentUsers = filteredUsers.slice(indexOfFirstItem, indexOfLastItem);

    return (
        <>
            <div className='container-fluid mt-6'>
                <h1 className='text-center mt-5 mb-5'><i className="bi bi-people-fill me-4"></i> Lista de Usuarios</h1>
                <SearchBar 
                    searchTerm={searchTerm} 
                    handleSearchChange={e => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(1);
                    }}
                />

                <UserTable
                    users={currentUsers}
                    currentPage={currentPage}
                    itemsPerPage={itemsPerPage}
                    handleSort={handleSort}
                    sortField={sortField}
                    sortOrder={sortOrder}
                    onSuspend={setUserToSuspend}
                    onDelete={setUserToDelete}
                />

                <Pagination
                    itemsPerPage={itemsPerPage}
                    totalItems={filteredUsers.length}
                    currentPage={currentPage}
                    paginate={setCurrentPage}
                />

                <SuspendModal 
                    show={!!userToSuspend}
                    title={userToSuspend?.suspended
                        ? 'Confirmar Activación'
                        : 'Confirmar Suspensión'
                    }
                    message={userToSuspend?.suspended
                        ? '¿Estás seguro de que deseas activar al usuario?'
                        : '¿Estás seguro de que deseas suspender al usuario?'
                    }
                    icon={userToSuspend?.suspended
                        ? <i className="bi bi-eye-fill me-2"></i>
                        : <i className="bi bi-eye-slash-fill me-2"></i>
                    }
                    funsuspend={confirmSuspend} 
                    onClose={() => setUserToSuspend(null)} 
                />
                <DeleteModal 
                    show={!!userToDelete}
                    message={"¿Realmente deseas eliminar este registro? Este proceso no se puede deshacer."}
                    fundelete={confirmDelete}
                    onClose={() => setUserToDelete(null)}
                />
                <SuccessModal show={!!success} message={success} onClose={() => setSuccess('')} />
                <ErrorModal show={!!error} message={error} onClose={() => setError('')} />
            </div>
        </>
    );
}